import SectionHeading from "./SectionHeading";
import { searchDirections } from "@/mocks/catalog";

const organizeSteps = [
  {
    id: "o1",
    icon: "ri-layout-grid-line",
    title: "按类型分区",
    desc: "把作品按内容形态拆成剧情、企划、合集、纪念等类型，先确定方向再往下看。",
  },
  {
    id: "o2",
    icon: "ri-node-tree",
    title: "按合集整理",
    desc: "把零散条目重新编排成套装，用年份、主题、精选三种思路组织。",
  },
  {
    id: "o3",
    icon: "ri-filter-3-line",
    title: "按标签检索",
    desc: "每个条目都带有标签与编号，可在本页直接筛选，缩小到具体范围。",
  },
];

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-content px-4 md:px-8">
        <SectionHeading
          eyebrow="主题概览"
          title="先弄清楚：同一个主题，为什么会有六种搜索方向"
          desc="当用户搜索「三上悠亚电影」时，真实意图往往并不相同：有人想了解作品整体，有人想找成体系的合集，也有人只想要一份能检索的清单。下面把这些方向拆开说明，方便你判断自己属于哪一类。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <ol className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {searchDirections.map((dir, index) => (
                <li
                  key={dir.id}
                  className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5"
                >
                  <div className="flex items-center gap-2">
                    <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 font-heading text-xs font-semibold text-accent-800">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{dir.keyword}</h3>
                  </div>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{dir.desc}</p>
                </li>
              ))}
            </ol>
          </div>

          <div className="lg:col-span-2">
            <div className="flex h-full flex-col rounded-lg border border-background-200/70 bg-secondary-100/70 p-5 md:p-6">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">本站怎么组织这些内容</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                页面不追求把所有条目一次性铺开，而是先给结构、再给清单，让你按需深入。
              </p>
              <ul className="mt-5 flex flex-col gap-4">
                {organizeSteps.map((step) => (
                  <li key={step.id} className="flex items-start gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{step.title}</div>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600">{step.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}